<template>
  <section>
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-select v-model="filters.AwardId" placeholder="请选择奖项名称">
            <el-option
              label="--请选择奖项名称--"
              :value="0"
              :key="0"
            ></el-option>
            <el-option
              v-for="item in awardNameList"
              :label="item.AwardName"
              :value="item.Id"
              :key="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <!-- <el-select
            v-model="filters.CompanyNameCN"
            placeholder="企业名称（中文）"
            :loading="loadingCompanyName"
            filterable
            default-first-option
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in CompanyList"
              :key="item.companyName"
              :label="item.companyName"
              :value="item.companyName"
            ></el-option>
          </el-select> -->
          <el-input
            v-model="filters.CompanyNameCN"
            placeholder="企业名称（中文）"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.ContactName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.Status" placeholder="请选择状态">
            <el-option
              v-for="item in stateList"
              :label="item.Name"
              :value="item.Value"
              :key="item.Value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.IsEnabled" placeholder="请选择是否关闭">
            <el-option
              label="全部(是否关闭)"
              :value="null"
              :key="0"
            ></el-option>
            <el-option label="开启" :value="true" :key="1"></el-option>
            <el-option label="关闭" :value="false" :key="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      row-key="Id"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="填报编号" width="70"></el-table-column>
      <el-table-column
        prop="CompanyNameCN"
        label="企业工商登记名称"
        width=""
      ></el-table-column>
      <el-table-column
        prop="SCC"
        label="统一社会信用代码"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="AwardTypeName"
        label="填报奖项名称"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="填报手机号码"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="填报时间"
        width="90"
      ></el-table-column>
      <el-table-column
        prop="OwnerUesrName"
        label="客户所属人"
        width="90"
      ></el-table-column>
      <el-table-column
        prop="RecommendInstitution"
        label="推荐机构"
        width="100"
      ></el-table-column>
      <el-table-column prop="" label="是否可用" width="80">
        <template slot-scope="scope">
          <el-switch
            @change="enabledChange(scope)"
            v-model="scope.row.IsEnabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="当前状态" width="80">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.Status === 1">草稿</el-tag>
          <el-tag type="danger" v-else-if="scope.row.Status === 2"
            >未审核</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.Status === 3">待修改</el-tag>
          <el-tag type="warning" v-else-if="scope.row.Status === 4"
            >待终审</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.Status === 5"
            >通过</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <span
            v-for="item in tableButtonList"
            :key="item.id"
            style="padding-left: 10px"
          >
            <el-button
              type="text"
              v-bind:key="item.id"
              v-prevent-re-click
              v-show="!item.IsHide"
              :disabled="
                (item.name == '申报短信' && scope.row.Status !== 1) ||
                (item.name == '补录短信' && scope.row.Status !== 3)
              "
              @click="callFunc(item, scope.row)"
              >{{ item.name }}</el-button
            >
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import {
  getAwardNameList,
  getSlyFuzzySearchList,
  getAwardStatusList,
  getAwardApplicationList,
  submitSendnotice,
  getAttachmentUrl,
  enabledAwardApplication,
  asyncOwner,
} from '../../api/api'
import store from '@/store'
import { saveAs } from 'file-saver'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      listLoading: false, // 数据列表刷新
      topButtonList: [],
      CompanyList: [], //企业名称
      loadingCompanyName: false, // 适用活动 加载效果
      awardNameList: [], // 奖项活动名称列表
      tableButtonList: [],
      filters: {
        AwardId: 0,
        CompanyNameCN: '',
        CompanyShortName: '',
        ContactName: '',
        Status: 0,
        IsEnabled: null,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      stateList: [], // 申报状态
      tabData: [], // 列表数据
      currentRow: {},
    }
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      console.log('------callFunc-----')
      console.log(row)
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 详情按钮
    handleInfo() {
      store.commit('saveAwardDetailId', this.currentRow.Id)
      store.commit('saveAwardId', this.currentRow.AwardId)
      // this.$router.push(`/DetpActivity/AwardDetail`)
      const routeUrl = this.$router.resolve({
         path: '/DetpActivity/AwardDetail'
      })
      window.open(routeUrl.href, '_blank')
    },
    // 申报短信
    handleDeclareSms() {
      let sendnotice = {
        Id: this.currentRow.Id,
        EncryptId: '',
        SignName: 'HRoot',
        TemplateCode: 'SMS_465675201',
        Remark: '',
      }
      submitSendnotice(sendnotice).then((res) => {
        console.log('sms res', res)
        if (res.data.success) {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 补录短信
    handleFillinSms() {
      console.log(' 补录短信')
      // 发送短信
      let sendnotice = {
        Id: this.currentRow.Id,
        EncryptId: '',
        SignName: 'HRoot',
        TemplateCode: 'SMS_465665188',
        Remark: this.dialogForm.content,
      }
      submitSendnotice(sendnotice).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'success',
          })
        } else {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 导出列表
    handleExport() {
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/AwardApplication/export`
      var xhr = new XMLHttpRequest()
      xhr.open('post', url, true)
      // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验

      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '卓越奖项申报列表' + new Date().getTime() + '.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(JSON.stringify(this.filters))
    },
    // 导出附件
    handleFileExport() {
      // const compName = this.currentRow.CompanyNameCN
      // const zipName = compName + '_附件列表' + new Date().getTime()
      // // Id：填报记录的ID；AwardApplicationReplenishId：补录数据的ID； Type：3 代表补交附件
      // const params = {
      //   Id: this.currentRow.Id,
      //   ZipName: zipName,
      // }

      // this.$notify({
      //   title: '成功',
      //   message: '正在下载，请耐心等待！',
      //   type: 'success',
      //   duration:8000
      // });
      // getAttachmentUrl(params).then((res) => {
      //   console.log('file res', res)
      //   if (res.data.success) {
      //     saveAs(res.data.response, zipName + '.zip')
      //   }
      // })

      this.$notify({
        title: '成功',
        message: '正在下载，请耐心等待！',
        type: 'success',
        duration: 5000,
      })
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/AwardApplication/attachment/export`
      const xhr = new XMLHttpRequest()
      const compName = this.currentRow.CompanyNameCN
      const zipName = compName + '_附件列表' + new Date().getTime()
      xhr.open('post', url, true)
      // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验

      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response
          console.log('blob', blob)
          saveAs(blob, zipName + '.zip')
          // var reader = new FileReader()
          // reader.readAsDataURL(blob) // 转换为base64
          // reader.onload = function (e) {
          //   var a = document.createElement('a') // 创建一个a标签用于下载
          //   a.download = compName + '_附件列表' + new Date().getTime() + '.zip' //文件名
          //   a.href = e.target.result
          //   a.click()
          //   $(a).remove()
          // }
        }
      }
      // Id：填报记录的ID；AwardApplicationReplenishId：补录数据的ID； Type：3 代表补交附件
      const params = {
        Id: this.currentRow.Id,
      }
      xhr.send(JSON.stringify(params))
    },

    // 企业名称
    remoteMethod(query) {
      if (query !== '') {
        this.loadingCompanyName = true
        let debItem = null
        if (debItem) {
          clearTimeout(debItem)
        }

        debItem = setTimeout(() => {
          getSlyFuzzySearchList(query).then((res) => {
            if (res.data.success) {
              this.CompanyList = res.data.response.data.data
              this.loadingCompanyName = false
            }
          })
        }, 500)
      }
    },

    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getAwardApplicationList(this.filters).then((res) => {
        if (res.data.success) {
          this.tabData = res.data.response.data
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.listLoading = false
        }
      })
    },
    handleAsyncOwner() {
      if (!this.filters.AwardId) {
        this.$message({
          message: '请选择奖项名称', //res.data.msg,
          type: 'error',
        })
        return
      }
      asyncOwner(this.filters.AwardId).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg, //res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 获取奖项活动名称列表
    getAwardNameList() {
      getAwardNameList().then((res) => {
        if (res.data.success) {
          this.awardNameList = res.data.response
        } else {
          return false
        }
      })
    },
    // 奖项状态列表
    getAwardStatusList() {
      getAwardStatusList().then((res) => {
        if (res.data.success) {
          this.stateList = res.data.response
        } else {
          return false
        }
      })
    },
    enabledChange(scope) {
      enabledAwardApplication({
        Id: scope.row.Id,
        IsEnabled: scope.row.IsEnabled,
      }).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    this.getAwardNameList()
    this.getAwardStatusList()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
    this.tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 1
    })
  },
  created() {
    this.handleQuery()
  },
}
</script>
